import React, { useEffect, useState } from "react";
import { Box, Paper, Button } from "@mui/material";
import PaySlipHeader from "./components/payslip.header";
import PayslipEmployeeDetail from "./components/Payslip.employee";
import PayslipEarnings from "./components/Payslip.Earnings";
import { useNavigate } from "react-router-dom";
import PayslipDeductioin from "./components/payslip.deductioin";
import PayslipNetpay from "./components/Payslip.Netpay";
import PaySlipFooter from "./components/payslip.footer";
import { getEmpPaySlipDefault, insertPayslipData } from "../../api/payslipApis";
import { showAlert } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import { useDispatch, useSelector } from "react-redux";
// import converter from "number-to-words"
export default function PayslipForm() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [change, setChange] = useState(false);
  const [paySlipData, setPaySlipData] = useState({});
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    employee_code: "",
    pay_date: "",
    employee: "",
    pay_period: "",
    father_name: "",
    bank_name: "",
    designation: "",
    account_number: "",
    department: "",
    ifsc_code: "",
    pan_number: "",
    payment_mode: "",
    joining_date: "",
    uan_number: "",
    work_location: "",
    effective_days: "",
    tax_deducted_at_source: "",
    epf: "",
    health_insurance: "",
    other_deductions: "",
    total_deductions: "",
    basic_pay: "",
    house_rent_allowance: "",
    special_allowance: "",
    transportaion_allowance: "",
    mobile_tel_allowance: "",
    city_compensatory_allowance: "",
    food_allowance: "",
    other_allowance: "",
    over_time: "",
    bonus: "",
    reimbursement: "",
    other_earnings: "",
    notes: "",
    net_pay_in_words: "",
    net_pay: "",
    header1: "SALARY SLIP",
    header2: "VASTEDGE CLOUD SOLUTIONS PVT LTD",
    header3: "CAPITAL GREENS, 15 SHIVAJI MARG, NEW DELHI 110015",
    footer1:
      "The tax has been deducted tentatively, after considering the maximum limit of tax-saving investment.",
    footer2:
      "The reimbursement amount and Other Earning is not part of the CTC.",
    footer3:
      "This is a system-generated Pay slip and does not require a signature.",
  });
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // console.log(`Setting ${name} to value:`, value);
    if (name === "employee") {
      getEmpoyeeDataDefault(value);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value || "",
    }));

    setChange(true);
  
  };
 
  async function getEmpoyeeDataDefault(empId) {
    if (empId) {
      try {
        const { data } = await getEmpPaySlipDefault(empId, user.token);
  
       
        if (data?.EmpPersonal?.length > 0) {
          const personalData = data.EmpPersonal[0];
          setFormData((prevFormData) => ({
            ...prevFormData,
            employee_code: personalData.employeeid,
            father_name: personalData.father_name,
            bank_name: personalData.bank_name,
            employee: personalData.user_id,
            account_number: personalData.account_number,
            designation: personalData.designation,
            department: personalData.department,
            ifsc_code: personalData.ifsc_code,
            pan_number: personalData.pan,
            payment_mode: personalData.payment_mode,
            joining_date: formatDateToDDMMYYYY(personalData.joining_date),
            uan_number: personalData.uan_number,
            work_location: personalData.job_location,
            effective_days: personalData.effective_days,
          }));
        }
  
        
        if (data?.EmpSalary?.length > 0) {
          const salaryData = data.EmpSalary[0];
          setFormData((prevFormData) => ({
            ...prevFormData,
            health_insurance: salaryData.health_insurance,
            other_deductions: salaryData.other_deductions,
            total_deductions: salaryData.total_deductions,
            basic_pay: salaryData.basic_pay,
            house_rent_allowance: salaryData.house_rent_allowance,
            special_allowance: salaryData.special_allowance,
            transportaion_allowance: salaryData.transportaion_allowance,
            mobile_tel_allowance: salaryData.mobile_tel_allowance,
            city_compensatory_allowance: salaryData.city_compensatory_allowance,
            food_allowance: salaryData.food_allowance,
            other_allowance: salaryData.other_allowance,
            bonus: salaryData.bonus,
            over_time: salaryData.over_time,
            reimbursement: salaryData.reimbursement,
          }));
        } else {
          
          setFormData((prevFormData) => ({
            ...prevFormData,
            health_insurance: "",
            other_deductions: "",
            total_deductions: "",
            basic_pay: "",
            house_rent_allowance: "",
            special_allowance: "",
            transportaion_allowance: "",
            mobile_tel_allowance: "",
            city_compensatory_allowance: "",
            food_allowance: "",
            other_allowance: "",
            bonus: "",
            over_time: "",
            reimbursement: "",
          }));
        }
  
        console.log(formData.employee_code, "employee_code formDatass");
        console.log(formData, "formDatass");
      } catch (error) {
        // handleAxiosError(error, dispatch);
      }
    }
  }
  

  useEffect(() => {
    setFormData((prevFormData) => {
      const totalEarning =
        parseFloat(prevFormData.basic_pay || 0.0) +
        parseFloat(prevFormData.house_rent_allowance || 0.0) +
        parseFloat(prevFormData.bonus || 0.0) +
        parseFloat(prevFormData.special_allowance || 0.0) +
        parseFloat(prevFormData.transportaion_allowance || 0.0) +
        parseFloat(prevFormData.mobile_tel_allowance || 0.0) +
        parseFloat(prevFormData.city_compensatory_allowance || 0.0) +
        parseFloat(prevFormData.food_allowance || 0.0) +
        parseFloat(prevFormData.other_allowance || 0.0) +
        parseFloat(prevFormData.over_time || 0.0) +
        parseFloat(prevFormData.reimbursement || 0.0) +
        parseFloat(prevFormData.other_earnings || 0.0);

      const totalDeduction =
        parseFloat(prevFormData.tax_deducted_at_source || 0.0) +
        parseFloat(prevFormData.epf || 0.0) +
        parseFloat(prevFormData.health_insurance || 0.0) +
        parseFloat(prevFormData.other_deductions || 0.0);

      return {
        ...prevFormData,
        total_earnings: totalEarning,
        total_deductions: totalDeduction,
        net_pay: totalEarning - totalDeduction,
        net_pay_in_words: numberToWords(totalEarning - totalDeduction || 0),
      };
    });
    setChange(false);
  }, [change]);

  const onformSubmit = async (event) => {
    event.preventDefault();
    try {
      const res = await insertPayslipData(formData, user.token);
      dispatch(showAlert(res.data.msg));
      navigate("/Payslip-list");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  function numberToWords(number) {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (number < 0 && !open) {
      dispatch(showAlert("The NetPay Can't be negative."));
      setOpen(true);
      return;
    }

    if (number === 0) return "Zero";

    let words = "";
    if (number < 0) {
      words += "Minus ";
      number = Math.abs(number);
    }

    if (number >= 10000 && number < 11000) {
      words += "Ten Thousand ";
      number %= 1000;
    }

    if (number >= 1000000000) {
      words += numberToWords(Math.floor(number / 1000000000)) + " Billion ";
      number %= 1000000000;
    }
    if (number >= 1000000) {
      words += numberToWords(Math.floor(number / 1000000)) + " Million ";
      number %= 1000000;
    }
    if (number >= 1000) {
      words += numberToWords(Math.floor(number / 1000)) + " Thousand ";
      number %= 1000;
    }
    if (number >= 100) {
      words += numberToWords(Math.floor(number / 100)) + " Hundred ";
      number %= 100;
    }
    if (number >= 20) {
      words += tens[Math.floor(number / 10)];
      if (number % 10 !== 0) {
        words += " " + ones[number % 10];
      }
    } else if (number >= 10) {
      words += teens[number - 10];
    } else if (number > 0) {
      words += ones[number];
    }

    return words.trim();
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PaySlipHeader
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipEmployeeDetail
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipEarnings
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipDeductioin
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipNetpay
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PaySlipFooter
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box
          sx={{
            ml: 10,
            m: 5,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={() => {
              navigate("/Payslip-list");
            }}
            sx={{ ml:7,borderRadius: "10px", fontWeight: "bold" }}
            variant="contained"
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            sx={{ mr: 7, borderRadius: "10px", fontWeight: "bold" }}
            variant="contained"
            color="info"
            onClick={onformSubmit}
          >
            Create
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}

function formatDateToDDMMYYYY(dateString) {
  if (!dateString) return ""; // Return empty string if input is falsy

  const parts = dateString.split("/");
  if (parts.length !== 3) return ""; // Invalid date format

  const day = parts[1];
  const month = parts[0];
  const year = parts[2];

  return `${year}-${month}-${day}`;
}
